import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useForm = (optionsToDisplay) => {
  const { addButton, editAction, deleteAction } = optionsToDisplay;

  const [listAuthor, setListAuthor] = useState([]);
  const [totalItems, setTotalItems] = useState(null);
  const [totalPages, setTotalPages] = useState(null);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [query, setQuery] = useState({ page: null, order: 'name DESC', keyword: '', limit: 10 });
  const [isDisplayed, setIsDisplayed] = useState(null);
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const page = parseInt(queryParams.get('page'));
    const order = queryParams.get('order');
    const keyword = queryParams.get('keyword');
    setQuery((prev) => ({
      ...prev,
      page: page ? page - 1 : 0,
      order: order ? order : query.order,
      keyword: keyword ? keyword : '',
    }));
  }, [location]);

  useEffect(() => {
    if (query.page !== null) {
      findAllAuthor();
    }
  }, [query, isDisplayed]);

  const findAllAuthor = () => {
    setLoading(true);
    AxiosInstance.get('/author', {
      params: { ...query, display: isDisplayed },
    })
      .then((response) => {
        setListAuthor(response.data.items);
        setTotalPages(response.data.totalPages);
        setTotalItems(response.data.totalItems);
        setLoading(false);
      })
      .catch((error) => {
        Swal.fire(t('author.ERROR_GET_AUTHORS'), '', 'error');
        setLoading(false);
      });
  };

  const createAuthorApi = (name) => {
    setLoading(true);
    AxiosInstance.post('/author', { name: name })
      .then((res) => {
        Swal.fire(t('author.SUCCESS_CREATE_AUTHOR'), '', 'success');
        findAllAuthor();
        setLoading(false);
      })
      .catch((error) => {
        Swal.fire(t('author.ERROR_CREATE_AUTHOR'), '', 'error');
        setLoading(false);
      });
  };

  const createAuthor = () => {
    Swal.fire({
      title: t('swal.author.create'),
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off',
      },
      showCancelButton: true,
      confirmButtonText: t('swal.confim'),
      cancelButtonText: t('swal.cancel'),
      showLoaderOnConfirm: true,
      preConfirm: (name) => {
        createAuthorApi(name);
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
  };

  const updateAuthorApi = (id, name) => {
    setLoading(true);
    AxiosInstance.patch(`/author/${id}`, { name: name })
      .then((res) => {
        Swal.fire(t('author.SUCCESS_UPDATE_AUTHOR'), '', 'success');
        findAllAuthor();
        setLoading(false);
      })
      .catch((error) => {
        Swal.fire(t('author.ERROR_UPDATE_AUTHOR'), '', 'error');
        setLoading(false);
      });
  };

  const updateAuthor = (id, oldName) => {
    history.push({
      pathname: '/author/update',
      params: {
        id: id,
      },
    });
  };

  const deleteAuthor = (id) => {
    Swal.fire({
      title: t('swal.are_you_sure'),
      text: t('swal.delete_permanently'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: t('swal.yes_delete'),
      cancelButtonText: t('swal.no'),
    }).then((result) => {
      if (result.isConfirmed) {
        AxiosInstance.delete('/author/' + id)
          .then((response) => {
            Swal.fire(t('author.SUCCESS_DELETE_AUTHOR'), '', 'success');
            findAllAuthor();
          })
          .catch((error) => {
            Swal.fire(t('author.ERROR_DELETE_AUTHOR'), '', 'error');
          });
      }
    });
  };

  const attributes = [
    { name: 'name', title: t('author.name'), nestedObject: [], type: 'text', order: true },
    { name: 'display', title: t('author.display'), nestedObject: [], type: 'author_display', order: false },
  ];

  const actions = {
    details: null,
    create: addButton && createAuthor,
    delete: deleteAction && deleteAuthor,
    update: editAction && updateAuthor,
  };

  return {
    attributes,
    actions,
    listAuthor,
    findAllAuthor,
    totalPages,
    loading,
    query,
    isDisplayed,
    setIsDisplayed,
  };
};

export default useForm;
